import * as React from "react";

const SvgOverview = ({ ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path d="M2080 4794 c-910 -123 -1637 -854 -1754 -1762 -111 -864 328 -1696
1104 -2091 415 -211 880 -273 1345 -180 202 41 492 157 657 262 31 21 61 37
65 37 4 0 163 -155 353 -345 390 -389 398 -395 541 -403 243 -14 430 170 417
411 -8 150 -11 154 -403 547 -190 190 -345 349 -345 354 0 5 18 37 39 71 282
447 373 1038 241 1566 -203 813 -891 1426 -1718 1533 -151 19 -397 19 -542 0z
m598 -422 c688 -150 1197 -688 1298 -1374 22 -149 15 -420 -15 -556 -47 -218
-147 -450 -269 -622 -86 -122 -270 -306 -392 -392 -176 -125 -398 -221 -623
-270 -88 -19 -132 -22 -322 -22 -190 0 -234 3 -320 22 -228 50 -450 146 -625
270 -122 86 -306 270 -392 392 -125 176 -221 398 -270 623 -19 88 -22 132 -22
322 0 190 3 234 22 322 49 225 145 447 270 623 85 121 270 306 392 392 175
124 409 225 621 267 153 30 148 29 359 26 148 -3 217 -8 288 -23z"/>
<path d="M2150 2765 l0 -815 205 0 205 0 0 815 0 815 -205 0 -205 0 0 -815z"/>
<path d="M1330 2560 l0 -610 205 0 205 0 0 610 0 610 -205 0 -205 0 0 -610z"/>
<path d="M2970 2355 l0 -405 205 0 205 0 0 405 0 405 -205 0 -205 0 0 -405z"/>
    </g>
  </svg>
);

export default SvgOverview;
